<template>
  <data-card title="Total Elementos" :fact="total_elementos" icon="fal fa-binoculars" :action="false" @borrar_widget="borrar_widget('TotalElementos'); $emit('widget_eliminado','TotalElementos')">
  </data-card>
</template>

<script>
import DataCard from "@/components/cards/DataCard.vue";
import apiExtract from "@/api/modules/extract";
import { mapActions } from 'vuex';
export default {
  data(){
    return {
      total_elementos:null
    };
  },
  components:{
    DataCard
  },
  methods:{
    getData(){
      apiExtract.getAllElementsCounts(this.$route.query.process_id)
      .then((resp)=>{
          if(resp){
            this.total_elementos = resp.data.total;
          }
      })
    },
    ...mapActions({
      borrar_widget: 'auth/removeWidget'
    })
  },
}
</script>

<style >
</style>
